import script from "./ChatMsgBody.vue?vue&type=script&lang=ts"
export * from "./ChatMsgBody.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__